import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd">
      <path fill="#F04E98" d="M32,9 L32,2.5 C32,1.119 30.881,0 29.5,0 L2.5,0 C1.119,0 0,1.119 0,2.5 L0,9 L32,9 Z"/>
      <polygon fill="#00BFB3" points="0 20 32 20 32 12 0 12"/>
      <path fill="#0080D5" d="M14.5,23 L0,23 L0,29.5 C0,30.881 1.119,32 2.5,32 L14.5,32 L14.5,23 Z"/>
      <path fill="#FEC514" d="M17.5,23 L17.5,32 L29.5,32 C30.881,32 32,30.881 32,29.5 L32,23 L17.5,23 Z"/>
    </g>
  </svg>
);
